/* Brand shelves share one collection feed and the theme's rendered product cards. */
(() => {
  const initialise = () => {
    const container = document.querySelector('[data-brand-shelves]');
    const dataElement = document.getElementById('epic-brand-shelf-data');
    if (!container || !dataElement || container.dataset.ready) return;
    container.dataset.ready = 'true';

    const normalise = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const hairTag = value => normalise(value).replace(/^hair thinning$/, 'thinning hair').replace(/^colored hair$/, 'coloured hair').replace(/^blond hair$/, 'blonde hair');
    const hairPattern = /^(blonde|coloured|curly|damaged|dry|fine|frizzy|oily|normal|thick|thin|thinning|coarse|straight|wavy|mature|textured) hair$/;
    const config = JSON.parse(dataElement.textContent);
    const conditions = String(config.conditions || '').split(',').map(tag => tag.trim().toLowerCase()).filter(Boolean);
    const vendors = config.vendors.map(vendor => ({...vendor, products: [], filtered: [], loaded: 0, rendering: false, visible: false}));
    const vendorMap = new Map(vendors.flatMap(vendor => (vendor.names || [vendor.name]).map(name => [normalise(name), vendor])));
    const productIds = new Set();
    const hairTypes = new Set();
    const search = document.querySelector('[data-collection-search]');
    const hair = document.querySelector('[data-collection-hair]');
    const filterStatus = document.querySelector('[data-collection-filter-status]');
    const loadStatus = document.querySelector('[data-brand-load-status]');
    const retry = document.querySelector('[data-brand-load-retry]');
    const sortButton = document.querySelector('.filterShelf-sort-btn');
    const sortMenu = document.querySelector('.filterShelf-sort');
    let sortOrder = 'curated';
    let searchTimer;
    let nextPage = 1;
    let loading = false;
    let complete = false;
    let notificationFrame;

    const sliderFor = vendor => document.getElementById(vendor.handle)?.querySelector('.productShelfSlider');
    const activeFilter = () => Boolean(normalise(search.value) || hair.value);
    const notifyDiscounts = () => {
      cancelAnimationFrame(notificationFrame);
      notificationFrame = requestAnimationFrame(() => document.dispatchEvent(new CustomEvent('la:dn:collection:updated')));
    };
    const productSlide = (product, index) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide mr-3 last-of-type:mr-0 !w-40 xl:!w-56';
      slide.dataset.tags = product.tags.join(',');
      slide.dataset.price = product.price;
      slide.dataset.index = index;
      slide.innerHTML = product.card;
      return slide;
    };
    const addEndCard = (vendor, swiper) => {
      if (complete && vendor.loaded >= vendor.filtered.length && vendor.card && !vendor.endAdded) {
        vendor.endAdded = true;
        swiper.appendSlide(vendor.card);
      }
    };
    const appendProducts = (vendor, swiper, amount) => {
      const start = vendor.loaded;
      const next = vendor.filtered.slice(start, start + amount);
      vendor.loaded += next.length;
      next.forEach((product, index) => swiper.appendSlide(productSlide(product, start + index)));
      addEndCard(vendor, swiper);
    };
    const fillShelf = (vendor, slider) => {
      const swiper = slider.swiper;
      if (!swiper || vendor.rendering) return;
      vendor.rendering = true;
      const indices = Array.from(slider.querySelector('.swiper-wrapper').children, (_, index) => index).slice(1);
      if (indices.length) swiper.removeSlide(indices);
      vendor.loaded = 0;
      vendor.endAdded = false;
      appendProducts(vendor, swiper, 10);
      if (vendor.shelf_talker && !activeFilter()) {
        const talker = document.createElement('div');
        talker.className = 'swiper-slide mr-3 !h-auto !w-40 rounded-xl bg-white border xl:!w-56';
        talker.innerHTML = vendor.shelf_talker;
        swiper.addSlide(Math.min(4, vendor.filtered.length + 1), talker);
      }
      swiper.slideTo(0, 0);
      swiper.update();
      vendor.rendering = false;
    };
    const loadMore = (vendor, slider) => {
      if (vendor.rendering || vendor.loaded >= vendor.filtered.length) return;
      vendor.rendering = true;
      appendProducts(vendor, slider.swiper, 10);
      slider.swiper.update();
      vendor.rendering = false;
      notifyDiscounts();
    };
    const initialiseShelf = vendor => {
      const slider = sliderFor(vendor);
      if (!slider || slider.swiper || !vendor.filtered.length) return;
      vendor.rendering = true;
      const swiper = new Swiper(slider, {
        slidesPerView: 'auto', freeMode: true, grabCursor: true,
        slidesPerGroupAuto: true, touchEventsTarget: 'container', touchReleaseOnEdges: true,
        navigation: {nextEl: slider.querySelector('.productShelfSlider-chev-r'), prevEl: slider.querySelector('.productShelfSlider-chev-l'), disabledClass: 'opacity-0'},
        scrollbar: {el: slider.querySelector('.productShelfSlider-horizontalClass'), draggable: true, hide: false, scrollbarDisabledClass: 'productShelfSlider-scrollbarDisabled', lockClass: 'productShelfSlider-scrollbarLock'},
        on: {reachEnd() { if (slider.swiper) loadMore(vendor, slider); }}
      });
      slider.swiper = swiper;
      vendor.rendering = false;
      fillShelf(vendor, slider);
    };

    const applyFilters = (reset = true) => {
      const words = normalise(search.value).split(' ').filter(Boolean);
      let matched = 0;
      vendors.forEach(vendor => {
        vendor.filtered = vendor.products.filter(product =>
          (!hair.value || product.hairTypes.includes(hair.value)) && words.every(word => product.searchText.includes(word))
        );
        if (sortOrder === 'price-low-high') vendor.filtered.sort((a, b) => a.price - b.price);
        if (sortOrder === 'price-high-low') vendor.filtered.sort((a, b) => b.price - a.price);
        matched += vendor.filtered.length;
        const slider = sliderFor(vendor);
        if (!slider) return;
        const empty = !vendor.filtered.length && (complete || activeFilter());
        slider.style.display = empty ? 'none' : '';
        slider.closest('.product-wrapper').hidden = empty;
        const count = slider.querySelector('.productShelfSlider-amount');
        if (count) count.textContent = vendor.filtered.length || (complete ? '0' : '…');
        if (empty) return;
        if (!slider.swiper && vendor.visible) initialiseShelf(vendor);
        else if (slider.swiper) {
          if (reset || activeFilter() || sortOrder !== 'curated') fillShelf(vendor, slider);
          else {
            vendor.rendering = true;
            if (vendor.loaded < 10) appendProducts(vendor, slider.swiper, 10 - vendor.loaded);
            addEndCard(vendor, slider.swiper);
            slider.swiper.update();
            vendor.rendering = false;
          }
        }
      });
      filterStatus.hidden = !activeFilter();
      filterStatus.textContent = matched ? filterStatus.dataset.countCopy.replace('__count__', matched) : complete ? filterStatus.dataset.emptyCopy : loadStatus.dataset.loadingCopy;
      notifyDiscounts();
    };

    const updateHairTypes = () => {
      const selected = hair.value;
      const existing = new Set(Array.from(hair.options, option => option.value));
      [...hairTypes].sort().forEach(type => {
        if (existing.has(type)) return;
        const option = document.createElement('option');
        option.value = type;
        option.textContent = type.charAt(0).toUpperCase() + type.slice(1);
        hair.append(option);
      });
      hair.value = selected;
    };
    const loadCollection = async () => {
      if (loading || complete) return;
      loading = true;
      container.setAttribute('aria-busy', 'true');
      loadStatus.hidden = false;
      loadStatus.textContent = loadStatus.dataset.loadingCopy;
      retry.hidden = true;
      const url = new URL(container.dataset.collectionUrl, window.location.origin);
      url.searchParams.set('view', 'epic-shelf-products');
      const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      try {
        while (nextPage) {
          url.searchParams.set('page', nextPage);
          const response = await fetch(url.toString());
          if (!response.ok) throw new Error('Collection products could not be loaded');
          const data = await response.json();
          if (!Array.isArray(data.products)) throw new Error('Invalid collection response');
          data.products.forEach(product => {
            const vendor = vendorMap.get(normalise(product.vendor));
            if (!vendor || productIds.has(product.id)) return;
            product.tags = Array.isArray(product.tags) ? product.tags : [];
            const productTags = product.tags.map(tag => tag.toLowerCase());
            if (conditions.length && !(config.matchAll ? conditions.every(tag => productTags.includes(tag)) : conditions.some(tag => productTags.includes(tag)))) return;
            productIds.add(product.id);
            product.price = Number(product.variants?.[0]?.price) || 0;
            product.searchText = normalise([product.title, product.vendor, ...product.tags].join(' '));
            product.hairTypes = product.tags.map(hairTag).filter(tag => hairPattern.test(tag));
            product.hairTypes.forEach(type => hairTypes.add(type));
            vendor.products.push(product);
          });
          const followingPage = Number(data.next_page) || null;
          if (followingPage && followingPage <= nextPage) throw new Error('Invalid collection pagination');
          nextPage = followingPage;
          complete = !nextPage;
          updateHairTypes();
          applyFilters(false);
        }
        loadStatus.hidden = true;
      } catch (error) {
        loadStatus.textContent = loadStatus.dataset.errorCopy;
        if (activeFilter() && !productIds.size) filterStatus.hidden = true;
        retry.hidden = false;
      } finally {
        loading = false;
        container.setAttribute('aria-busy', 'false');
      }
    };

    const closeSort = () => {
      sortMenu.style.display = 'none';
      sortButton.setAttribute('aria-expanded', 'false');
    };
    const chooseSort = order => {
      sortOrder = order;
      document.querySelectorAll('.filterShelf-orderFilter').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.order === order));
        if (button.dataset.order === order) document.querySelector('.filterShelf-text').textContent = button.textContent;
      });
      closeSort();
    };
    search.addEventListener('input', () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => applyFilters(), 160);
    });
    hair.addEventListener('change', () => { clearTimeout(searchTimer); applyFilters(); });
    sortButton.addEventListener('click', () => {
      const open = sortButton.getAttribute('aria-expanded') !== 'true';
      sortButton.setAttribute('aria-expanded', String(open));
      sortMenu.style.display = open ? 'block' : 'none';
    });
    document.querySelector('.filterShelf-close').addEventListener('click', closeSort);
    document.querySelectorAll('.filterShelf-orderFilter').forEach(button => button.addEventListener('click', () => {
      clearTimeout(searchTimer);
      chooseSort(button.dataset.order);
      applyFilters();
    }));
    document.addEventListener('click', event => { if (!event.target.closest('.epic-collection-sort')) closeSort(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') closeSort(); });
    document.querySelector('.clearFilters').addEventListener('click', () => {
      clearTimeout(searchTimer);
      search.value = '';
      hair.value = '';
      chooseSort('curated');
      applyFilters();
    });
    retry.addEventListener('click', loadCollection);
    document.addEventListener('allure:range:jump', event => {
      const vendor = vendors.find(item => item.handle === event.detail?.id);
      if (vendor) { vendor.visible = true; initialiseShelf(vendor); }
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const vendor = vendors.find(item => item.handle === entry.target.dataset.vendor);
        if (!vendor) return;
        vendor.visible = entry.isIntersecting;
        if (entry.isIntersecting) initialiseShelf(vendor);
      });
    }, {rootMargin: '0px 0px 150px 0px'});
    vendors.forEach(vendor => { const slider = sliderFor(vendor); if (slider) observer.observe(slider); });
    loadCollection();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
})();
